define('shoptheme/components/ui/scrollspy',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-scrollspy"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({

		blocks: null,

		$init: function() {
			this.blocks = $('[data-scrollspy-target]');
			this.blocks.each(function() {
				var block = $(this);
				$('body').scrollspy({ target: block.data('scrollspy-target') });
			});

		}

	});

});

